import { buildApiUrl, API_ENDPOINTS, apiRequest } from '../config/api.js'

export const workingTimesApi = {
  async getWorkingTimes(userId) {
    const url = buildApiUrl(API_ENDPOINTS.WORKING_TIMES.BY_USER(userId))
    const response = await apiRequest(url)
    return response.data || []
  },

  async getWorkingTimesWithDateRange(userId, startDate, endDate) {
    const url = buildApiUrl(API_ENDPOINTS.WORKING_TIMES.BY_USER_WITH_DATES(userId, startDate, endDate))
    return apiRequest(url)
  },

  async getWorkingTime(userId, id) {
    const url = buildApiUrl(API_ENDPOINTS.WORKING_TIMES.BY_USER_AND_ID(userId, id))
    return apiRequest(url)
  },

  async createWorkingTime(userId, data) {
    const url = buildApiUrl(API_ENDPOINTS.WORKING_TIMES.BY_USER(userId))
    return apiRequest(url, {
      method: 'POST',
      body: JSON.stringify(data),
    })
  },

  async updateWorkingTime(id, data) {
    const url = buildApiUrl(API_ENDPOINTS.WORKING_TIMES.BY_ID(id))
    return apiRequest(url, {
      method: 'PUT',
      body: JSON.stringify(data),
    })
  },

  async deleteWorkingTime(id) {
    const url = buildApiUrl(API_ENDPOINTS.WORKING_TIMES.BY_ID(id))
    return apiRequest(url, {
      method: 'DELETE',
    })
  },
}